<script setup lang="ts">
import { computed, inject, type Ref } from 'vue'
import { NodeViewWrapper } from '@tiptap/vue-3'
import { useI18n } from 'vue-i18n'
import { useUserStore } from '@/config/store/userStore'
import type { MentionablePerson } from './suggestion'
import ResourceImage from '@/components/resource/resourceImage.vue'

const props = defineProps<{
  node: {
    attrs: {
      id?: string
      firstname?: string
      lastname?: string
      picture?: string | null
      label?: string
    }
  }
}>()

const { t } = useI18n()
const userStore = useUserStore()
const mentionables = inject<Ref<MentionablePerson[] | null | undefined> | null>('mentionables', null)

const person = computed(() => {
  const id = String(props.node.attrs.id || '')
  const fromList = mentionables?.value?.find(m => String(m._id) === id)
  if (fromList) return fromList
  return {
    _id: id,
    firstname: props.node.attrs.firstname || '',
    lastname: props.node.attrs.lastname || '',
    picture: props.node.attrs.picture || null,
  }
})

const isMe = computed(() => String(person.value._id) === String(userStore.user?._id || ''))
const label = computed(() => {
  if (isMe.value) return t('modules.chat.mentionYou')
  const name = `${person.value.firstname || ''} ${person.value.lastname || ''}`.trim()
  return name || props.node.attrs.label || '—'
})
</script>

<template>
  <NodeViewWrapper
    as="span"
    class="mention mention-area__chip"
    :class="{ 'mention-area__chip--me': isMe }"
    contenteditable="false"
  >
    <ResourceImage
      :resource="person"
      width="w-[1.15rem]"
      height="h-[1.15rem]"
      shadow=""
      :popover="false"
      disable-link
      class="mention-area__avatar-wrap"
    />
    <span class="mention-area__label">@{{ label }}</span>
  </NodeViewWrapper>
</template>
